<template>
  <authenticated-layout>
    <div class="row">
      <div class="col-12">
        <produtos-catalogo-cards />
      </div>
    </div>
  </authenticated-layout>
</template>

<script>
import AuthenticatedLayout from "@/components/AuthenticatedLayout.vue";
import ProdutosCatalogoCards from "./components/ProdutosCatalogoCards.vue";

export default {
  name: "ProdutosCatalogo",
  components: {
    AuthenticatedLayout,
    ProdutosCatalogoCards,
  },
};
</script>
